// AUPRÉA — Étapes 14/15 : page admin « Bilans & clients »
import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { C, Select, Btn, DateInput } from "./shared";
import { API, hdrs } from "./integrationShared";
import { TYPES, TERRITOIRES, TRANCHES, F0, nomC } from "./bilansShared";
import { VueEnsemble } from "./BilansVue";
import { BilansReponses } from "./BilansReponses";
import { BilansListe, ParConsultant } from "./BilansListe";
import { BilansImports } from "./BilansImports";

const TABS = [["vue", "Vue d'ensemble"], ["reponses", "Analyse des réponses"], ["liste", "Bilans"], ["consultants", "Par consultant"], ["imports", "Réception des bilans"]];

const Filtres = ({ f, setF, cons }) => {
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  const box = { display: "flex", flexDirection: "column", gap: 3, fontSize: 10.5, color: C.mid, textTransform: "uppercase", minWidth: 130, flex: 1 };
  return (
    <div data-testid="bilans-filtres" style={{ display: "flex", flexWrap: "wrap", gap: 10, alignItems: "flex-start", background: "#fff", border: `.5px solid ${C.border}`, borderRadius: 12, padding: 12, marginBottom: 16 }}>
      <label style={box}>Du<DateInput value={f.du} onChange={v => setF({ ...f, du: v })} data-testid="filtre-du" /></label>
      <label style={box}>Au<DateInput value={f.au} onChange={v => setF({ ...f, au: v })} error={f.du && f.au && f.au < f.du ? "Date invalide : la fin est antérieure au début" : ""} data-testid="filtre-au" /></label>
      <label style={box}>Parcours<Select value={f.type} onChange={set("type")} data-testid="filtre-type"><option value="">Tous</option>{Object.entries(TYPES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</Select></label>
      <label style={box}>Consultant<Select value={f.conseiller_id} onChange={set("conseiller_id")} data-testid="filtre-consultant"><option value="">Tous</option>{cons.map(c => <option key={c.id} value={c.id}>{nomC(c)}</option>)}</Select></label>
      <label style={{ fontSize: 12, color: C.mid, display: "flex", gap: 5, alignItems: "center", paddingBottom: 10 }}><input type="checkbox" checked={f.equipe} onChange={set("equipe")} disabled={!f.conseiller_id} data-testid="filtre-equipe" />et son équipe</label>
      <label style={box}>Territoire<Select value={f.territoire} onChange={set("territoire")} data-testid="filtre-territoire"><option value="">Tous</option>{TERRITOIRES.map(t => <option key={t}>{t}</option>)}</Select></label>
      <label style={box}>Tranche d'âge<Select value={f.tranche} onChange={set("tranche")} data-testid="filtre-tranche"><option value="">Toutes</option>{TRANCHES.map(t => <option key={t}>{t}</option>)}</Select></label>
      <Btn small onClick={() => setF(F0)} data-testid="filtre-reset" style={{ marginBottom: 6 }}>Réinitialiser</Btn>
    </div>
  );
};

export default function BilansAdmin() {
  const [f, setF] = useState(F0);
  const [tab, setTab] = useState("vue");
  const [cons, setCons] = useState([]);
  const fx = useMemo(() => (f.du && f.au && f.au < f.du ? { ...f, du: "", au: "" } : f), [f]);
  useEffect(() => { axios.get(`${API}/conseillers`, hdrs()).then(r => setCons(r.data || [])); }, []);
  return (
    <div data-testid="bilans-admin">
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 14 }}>
        {TABS.map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`bilans-tab-${k}`}
            style={{ padding: "8px 16px", borderRadius: 999, border: `1px solid ${tab === k ? C.navy : C.border}`, background: tab === k ? C.navy : "#fff", color: tab === k ? "#fff" : C.mid, fontSize: 12, fontWeight: 600, cursor: "pointer", transition: "background-color .15s" }}>{l}</button>
        ))}
      </div>
      {tab !== "imports" && <Filtres f={f} setF={setF} cons={cons} />}
      {tab === "vue" && <VueEnsemble f={fx} />}
      {tab === "reponses" && <BilansReponses f={fx} />}
      {tab === "liste" && <BilansListe f={fx} cons={cons} />}
      {tab === "consultants" && <ParConsultant f={fx} />}
      {tab === "imports" && <BilansImports />}
      <div style={{ fontSize: 11, color: C.muted, marginTop: 18 }}>Page réservée à l'administration : les réponses des clients et les statistiques du réseau ne sont jamais accessibles aux consultants.</div>
    </div>
  );
}
